import z from "zod";

/**
 * ServicoProdutoSchema
 */

export const ServicoProdutoSchema = z.object({
  ativo: z.coerce.boolean(),
  produtoServico: z.string().nonempty('Este campo deve ser preenchido!'),
  tipo: z.coerce.number().default(1),
  unidade: z.string().optional(),
  norma: z.string().optional(),
});

/**
 * ServicoProdutoForm
 */

export type ServicoProdutoForm = z.infer<typeof ServicoProdutoSchema>;